import { AuthenticationRemoteDatasource } from "@authentication/data/datasources/authentication-remote.datasource";
import { AuthenticationStorageDatasource } from "@authentication/data/datasources/authentication-storage.datasource";
import { LoginUserMapper } from "@authentication/data/mappers/login-user.mapper";
import { AuthenticationImplRepository } from "@authentication/data/repositories/authentication.impl-repository";
import { UserSessionImplRepository } from "@authentication/data/repositories/user-session.impl-repository";
import type { AuthenticationRepository } from "@authentication/domain/repositories/authentication.repository";
import type { UserSessionRepository } from "@authentication/domain/repositories/user-session.repository";
import { AuthenticatedUserGetLoggedUseCase } from "@authentication/domain/usecases/authenticated-user-get-logged.usecase";
import { AuthenticatedUserIsLoggedUseCase } from "@authentication/domain/usecases/authenticated-user-is-logged.usecase";
import { AuthenticatedUserLoadCurrentUseCase } from "@authentication/domain/usecases/authenticated-user-load-current.usecase";
import { AuthenticationLoginUseCase } from "@authentication/domain/usecases/authentication-login.usecase";
import { AuthenticationLogoutUseCase } from "@authentication/domain/usecases/authentication-logout.usecase";
import { AuthenticationRequestMailToResetPasswordUseCase } from "@authentication/domain/usecases/authentication-request-mail-to-reset.password.usecase";
import { AuthenticationResetPasswordUseCase } from "@authentication/domain/usecases/authentication-reset-password.usecase";
import { authenticationTypes } from "@authentication/root/authentication-types.di";
import { DiModuleBuilder } from "@iot-platform/core";
import { ContainerModule } from "inversify";

const authenticationModule = new DiModuleBuilder();

authenticationModule.registerSubModules(() => ({
    datasources: new ContainerModule(({ bind }) => {
        bind(AuthenticationRemoteDatasource).toSelf();
        bind(AuthenticationStorageDatasource).toSelf();
    }),
    mappers: new ContainerModule(({ bind }) => {
        bind(LoginUserMapper).toSelf();
    }),
    repositories: new ContainerModule(({ bind }) => {
        bind<AuthenticationRepository>(
            authenticationTypes.repositories.AuthenticationRepository,
        ).to(AuthenticationImplRepository);
        bind<UserSessionRepository>(
            authenticationTypes.repositories.UserSessionRepository,
        )
            .to(UserSessionImplRepository)
            .inSingletonScope();
    }),
    useCases: new ContainerModule(({ bind }) => {
        bind(AuthenticatedUserGetLoggedUseCase).toSelf();
        bind(AuthenticatedUserIsLoggedUseCase).toSelf();
        bind(AuthenticatedUserLoadCurrentUseCase).toSelf();
        bind(AuthenticationLoginUseCase).toSelf();
        bind(AuthenticationLogoutUseCase).toSelf();
        bind(AuthenticationRequestMailToResetPasswordUseCase).toSelf();
        bind(AuthenticationResetPasswordUseCase).toSelf();
    }),
}));

authenticationModule.registerModule();

export { authenticationModule };
